/**
 * Returns subdivisions unavailable for hiring.
 *
 * This list also exists in engines/embedded_api/data/subdivisions.yml
 * Please keep those files in sync
 */
export const useExcludedSubdivisionsForCountry = (countryCode?: string) => {
  if (countryCode === "US") {
    return ["AL", "AK", "DE", "ID", "KY", "ME", "ND", "RI", "WV", "WY"]
  } else if (countryCode === "CA") {
    return ["NT", "NU", "YT"]
  }
  return []
}
